import AllView from './all';
import api from '@/services/billing';
import { BaseView, Filters, DataReq } from './view';

const typeTranslation: any = {
  AccountDeliveryItem: "deliveryitem",
  AccountInvoice: "invoice",
  AccountInvoiceItem: "invoiceitem",
  AccountLicence: "",
  AccountOrder: "order",
  AccountPaymentMethod: "",
  AccountSubscription: "subscription",
  OrderCoupon: "",
  Package: "",
  PackageDiscountClass: "",
  Setting: "",
  Transaction: "",
  View: "",
  XeroAccount: "",
  XeroInvoice: "",
  XeroTransaction: "",

};

export default class IView extends AllView {
  public Name = 'history';

  public get Headers(): any {
    return [
      ...super.Headers,
      {
        text: 'Version ID',
        name: 'version_id',
        value: 'v_id'
      },
      {
        text: 'Version Item ID',
        name: 'version_item_id',
        value: 'v_item_id'
      },
      {
        text: 'Version Item State',
        name: 'version_item_state',
        value: 'v_item_state'
      },
      {
        text: 'Version Account Id',
        name: 'version_account_id',
        value: 'v_account_id'
      },
      {
        text: 'Version Event',
        name: 'version_event',
        value: 'v_event'
      },
      {
        text: 'Version Updated By',
        name: 'version_updated_by',
        value: 'v_updated_by'
      },
      {
        text: 'Version Created At',
        name: 'version_created_at',
        value: 'v_created_at'
      }
    ];
  }

  public async Data(req: DataReq) {
    req.columns = ['id', 'item_type', 'item_id', 'item_state', 'account_id', 'event', 'updated_by', 'ob', 'created_at'];
    req.sources = ['version'];
    // req.filter = {
    //   condition: 'and',
    //   rules: [
    //     {
    //       key: 'item_state',
    //       operator: '=',
    //       value: 'PAID'
    //     },
    //     req.filter,
    //   ]
    // };
    req.pagination = {
      descending: true,
      sortBy: 'id',
      rowsPerPage: req.pagination ? req.pagination.rowsPerPage : 10,
      page: req.pagination ? req.pagination.page : 1,
    };
    const data = await api.ListPivotAll(req);
    const res: any = [];

    for (const d of data) {
      // d.ob.object_type = d.object_type;
      // d.ob.object_type = "order";

      res.push({
        object_type: typeTranslation[d.ob.item_type] || d.ob.item_type,
        v_id: d.ob.id,
        v_item_type: d.ob.item_type,
        v_item_id: d.ob.item_id,
        v_item_state: d.ob.item_state,
        v_account_id: d.ob.account_id,
        v_event: d.ob.event,
        v_updated_by: d.ob.updated_by,
        v_created_at: d.ob.created_at,
        ...d.ob.ob
      });
    }
    // console.log(res);
    return res;

  }

  public Filter(v: any) {
    return true;
  }

  public get DatasourceFilters() {
    const filters: any = [
      {
        name: 'date_range',
        text: 'Date Range',
        required: true,
        type: 'date-range',
        value: (data: any) => undefined
      },
      {
        name: 'item_type',
        text: 'Item Type',
        type: 'multi',
        multiple: true,
        items: () => [
          { val: "AccountOrder", text: "Orders" },
          { val: "AccountInvoice", text: "Invoices" },
          { val: "AccountSubscription", text: "Subscriptions" },
          { val: "AccountDeliveryItem", text: "Delivery Item" },
          { val: "AccountInvoiceItem", text: "Invoice Item" },
        ],
        selectMultiple: true,
        value: (selected: any) => {
          if (!selected) { return null; }
          if (Array.isArray(selected)) {
            if (!selected.length) { return null; }
            return selected;
          }
          return [selected];
        }
      },
      {
        name: 'account_id',
        text: 'Account',
        required: false,
        type: 'account',
        multiple: true,
        value: (selected: any) => {
          if (!selected) { return null; }
          if (Array.isArray(selected)) {
            if (!selected.length) { return null; }
            return selected.map((a: Account) => a.id);
          }
          return [selected.id];
        }
      },
      {
        name: 'item_state',
        text: 'Item State',
        required: false,
        type: 'multi',
        multiple: true,
        items: () => [
          // Common
          { val: 'DRAFT', text: 'Draft (O,I,S)' },

          // order & invoice
          { val: 'CREATED', text: 'Created (O,I)' },
          { val: 'PAID', text: 'Paid (O,I)' },

          // invoice & subscription
          { val: 'PENDING_PAYMENT', text: 'Pending Payment (O,S)' },

          // order
          { val: "PENDING_APPROVAL", text: "Pending Approval (O)" },
          { val: "APPROVAL_DECLINED", text: "Approval Declined (O)" },
          { val: "APPROVED", text: "Approved (O)" },

          // invoice
          { val: 'PAYING', text: 'Paying (I)' },
          { val: 'PAYMENT_FAILED', text: 'Payment Failed (I)' },
          { val: 'PAYMENT_RETRY', text: 'Payment Retry (I)' },
          { val: 'FINAL_PAYMENT_ATTEMPT_FAILED', text: 'Final Payment Attempt Failed (I)' },
          { val: 'CANCELED', text: 'Canceled (I)' },

          // subscription
          { val: 'ACTIVE', text: 'Active (S)' },
          { val: 'RENEWING', text: 'Renewing (S)' },
          { val: 'PENDING_CANCEL', text: 'Pending Cancel (S)' },
          { val: 'CANCELLED', text: 'Cancelled (S)' },
          // { val: 'PENDING_TRIAL_CREATE', text: 'Pending Trial Create (S)' },
        ],
        selectMultiple: false,
        value: (selected: any) => {
          if (!selected) { return null; }
          if (Array.isArray(selected)) {
            if (!selected.length) { return null; }
            return selected;
          }
          return [selected];
        }
      }
    ];

    // string filters
    // const stringFilters = [
    //   { name: 'account_code', text: 'Xero Account Code' },
    //   { name: 'category', text: 'Category' },
    //   { name: 'code', text: 'Code' },
    //   { name: 'country', text: 'Country' },
    //   { name: 'description', text: 'Description' },
    //   { name: 'reference', text: 'Reference' },
    //   { name: 'region', text: 'Region' },
    //   { name: 'title', text: 'Title' }
    // ]
    // for (let f of stringFilters) {
    //   filters.push({
    //     name: f.name,
    //     text: f.text,
    //     required: false,
    //     type: 'string',
    //     multiple: false,
    //     selectMultiple: false,
    //     value: (selected: any) => {
    //       if (!selected) { return null; }
    //       if (Array.isArray(selected)) {
    //         if (!selected.length) { return null; }
    //         return selected;
    //       }
    //       return [selected];
    //     }
    //   })
    // }

    // number filters
    const numberFilters = [
      // { name: "discount", text: "Discount" },
      // { name: "discount_rate", text: "Discount Rate" },
      // { name: "sku", text: "Sku" },
      // { name: "tax", text: "Tax" },
      // { name: "price", text: "Price" },
      // { name: "qty", text: "Qty" },
      // { name: "total", text: "Total" },
      // { name: "exchange_rate", text: "Exchange Rate" },
      // { name: "payment_attempts", text: "Payment Attempts" },
      { name: "item_id", text: "Item ID" }
    ];
    for (const f of numberFilters) {
      filters.push({
        name: f.name,
        text: f.text,
        required: false,
        type: 'number',
        multiple: false,
        selectMultiple: false,
        value: (selected: any) => {
          if (!selected) { return null; }
          if (Array.isArray(selected)) {
            if (!selected.length) { return null; }
            return selected;
          }
          return [selected];
        }
      });
    }

    return filters;
  }

}
